import React from "react";
import { cn } from "@/lib/utils";
import { Settings, LogOut } from "lucide-react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

interface SidebarFooterProps {
  isParentPortal?: boolean;
}

export function SidebarFooter({ isParentPortal = false }: SidebarFooterProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  
  // Check if we're in a parent portal route
  const inParentPortalSection = location.pathname.includes('/parent-portal');
  
  // For parent portal, we don't need a separate Settings link since Profile already exists in the sidebar
  const showSettingsLink = !isParentPortal && !inParentPortalSection;
  
  const handleSignOut = async () => {
    try {
      await signOut();
      toast.success("Signed out successfully");
      navigate("/auth");
    } catch (error) {
      toast.error("Failed to sign out");
      console.error("Sign out error:", error);
    }
  };
  
  return (
    <div className="mt-auto border-t pt-4 pb-4 px-4 space-y-2">
      {showSettingsLink && (
        <NavLink
          to="/admin/settings"
          className={({isActive}) => cn(
            "flex items-center justify-start py-2 px-4 rounded-md text-sm font-medium",
            isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
          )}
        >
          <Settings className="h-4 w-4" />
          <span className="ml-2">Settings</span>
        </NavLink>
      )}
      
      <button
        onClick={handleSignOut}
        className="flex w-full items-center justify-start py-2 px-4 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-accent/50"
      >
        <LogOut className="h-4 w-4" />
        <span className="ml-2">Sign Out</span>
      </button>
    </div>
  );
}

export default SidebarFooter;
